(ns hai.ui.utils.validate
  #?(:cljs (:require-macros hai.ui.utils.validate))
  #?(:cljs
     (:require
      [cljs.pprint :as pprint]
      [malli.core :as m]
      [malli.error :as me])))

#?(:cljs
   (defn pp-string
     [value]
     (with-out-str (pprint/pprint value))))

#?(:cljs
   (defn -absence-only?
     "True iff `value` fails `schema` purely because something required is absent -- the whole
     value is `nil`, or it's a map missing one or more required keys -- as opposed to something
     being present but the wrong shape. Used to decide whether a validation failure is an
     expected, benign, transient state (e.g. a required field that simply hasn't been filled in
     yet) rather than a likely bug worth logging loudly. Only meaningful when already known invalid."
     [schema value]
     (or (nil? value)
         (let [errors (:errors (m/explain schema value))]
           (and (seq errors)
                (every? #(= :malli.core/missing-key (:type %)) errors))))))

#?(:cljs
   (defn -format-validation-error
     [schema value fn-symbol line column ok-if-absent?]
     (when (and js/goog.DEBUG (not (and ok-if-absent? (-absence-only? schema value))))
       (let [explain (m/explain schema value)
             human (me/humanize explain)
             ;; `human`'s shape mirrors the schema's shape: for a `:map` schema it's a map (real
             ;; keys), but for a `[:vector ...]` (or other sequential) schema it's itself a vector
             ;; of per-index errors, so plain `keys` isn't meaningful/safe there — use indices.
             ks (cond
                  (map? human) (keys human)
                  (sequential? human) (range (count human))
                  :else [])]
         (str
          "Validation error\n"
          fn-symbol "\n"
          "Line " line "\n"
          "Column " column "\n"
          "\n"

          "Humanised:\n"
          (pp-string human)
          "\n"

          "Invalid sub-value:\n"
          ;; `select-keys` assumes a map; `(:value explain)` can just as easily be a vector (e.g.
          ;; for `[:vector ...]` schemas), so we look values up with `get` instead, which works for
          ;; both maps and indexed collections.
          (pp-string (into {} (map (fn [k] [k (get (:value explain) k)])) ks))
          "\n"

          "Value:\n"
          (pp-string (:value explain))
          "\n"

          "Schema:\n"
          (pp-string (m/form schema)))))))

#?(:clj
   (defmacro validate
     ([schema value] `(validate ~schema ~value false))
     ([schema value ok-if-absent?]
      (let [fn-symbol (str (-> &env :fn-scope first :info :ns)
                           "/"
                           (-> &env :fn-scope first :name))
            line (:line &env)
            column (:column &env)]
        `(let [valid?# (malli.core/validate ~schema ~value)]
           (when-not valid?#
             (when-let [validation-error# (-format-validation-error ~schema ~value ~fn-symbol ~line ~column ~ok-if-absent?)]
               (js/console.error validation-error#)))
           (when valid?# ~value))))))
